import { client as papClient } from '../generated/pap/client.gen';
import { client as pmClient } from '../generated/pm/client.gen';
import { client as notificationInAppClient } from '../generated/notification-inapp/client.gen';
import { client as notificationPrefClient } from '../generated/notification-pref/client.gen';
import { attachIfMatchHeader, attachStatusToError, captureEtagFromResponse } from './interceptors';

/**
 * Registers the shared etag / If-Match / error-status interceptors on every
 * generated client. Call once at app startup (see `src/index.tsx`).
 *
 * Base URLs are configured separately in each `*.runtime.ts` via the generated
 * `createClientConfig` hook; this module only wires the runtime behaviour that
 * cannot be expressed as static config.
 */
const clients = [papClient, pmClient, notificationInAppClient, notificationPrefClient];

let registered = false;

export function setupApiClients(): void {
  if (registered) return;
  registered = true;

  for (const client of clients) {
    client.interceptors.request.use((request) => attachIfMatchHeader(request));
    client.interceptors.response.use((response, request) =>
      captureEtagFromResponse(response, request)
    );
    client.interceptors.error.use((error, response) => attachStatusToError(error, response));
  }
}
